// extracted by mini-css-extract-plugin
export default {"wrapper":"PlaceholderLoaders_wrapper__DITtA"};